<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="请假类型"
      edit-title
      id-key="LeaveTypeId"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="请假类型" prop="LeaveTypeName">
          <el-input v-model="data.LeaveTypeName" placeholder="请输入请假类型"></el-input>
        </el-form-item>
        <!-- <el-form-item label="时间刻度" prop="Scale">
          <el-radio-group v-model="data.Scale">
            <el-radio :label="0">按天</el-radio>
            <el-radio :label="1">按小时</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="序号" prop="Sort">
          <el-input-number :min="0" v-model="data.Sort"></el-input-number>
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        LeaveTypeId: 0,
        LeaveTypeName: "",
        Scale: 0, //按天/按小时
        Sort: 0,
        Status: 1,
      },
      api: require("@/api/ent/leaveType").default,
      rules: {
        LeaveTypeName: [{ required: true, message: "请假类型不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(data) {
      this.api.getMaxSort().then((res) => {
        this.data.Sort = res.Data;
      });
    },
    onEditOpened(data) {},
  },
};
</script>